import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { Form, Input } from 'src/common';
import { useForm } from 'antd/lib/form/Form';
import debounce from 'lodash/debounce';
import { AdminCompaniesVars } from 'src/models/admin/Companies/types';
import { useAdminCompaniesVars } from 'src/models/admin/Companies/hooks';

type FormState = Pick<AdminCompaniesVars, 'id' | 'name'>;

export const TableFilter: FC = () => {
  const { t } = useTranslation();
  const [form] = useForm<FormState>();
  const [{ args }, updateCompaniesFilter] = useAdminCompaniesVars();

  const initialValues = useMemo(() => ({ id: args.id, name: args.name }), [args.id, args.name]);
  const onClick = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    event.stopPropagation();
  }, []);

  const onValuesChange = useMemo(
    () =>
      debounce((_, allValues: FormState) => {
        updateCompaniesFilter(allValues);
      }, 300),
    [updateCompaniesFilter]
  );

  return (
    <div className={styles.container}>
      <Form
        className={styles.filter}
        name={'searchCompany'}
        form={form}
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <Form.Item name={`name`} label={t('Company.companyName')} className={styles.filterField}>
          <Input placeholder={t('Common.search')} allowClear />
        </Form.Item>

        <Form.Item name={`id`} label={t('AdminPage.companyId')} className={styles.filterField}>
          <Input placeholder={t('Common.search')} onClick={onClick} allowClear />
        </Form.Item>
      </Form>
    </div>
  );
};

export default TableFilter;
